import styled from 'styled-components';

import colors from 'styles/colors';

export const Overlay = styled.div`
  .pm-overlay {
    position: fixed;
    inset: 0;
    z-index: 3000000000;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
    background: rgba(0, 0, 0, 0.5);
  }

  .pm-backdrop {
    position: absolute;
    inset: 0;
    border: none;
    padding: 0;
    background: transparent;
    cursor: default;
  }

  .pm-card {
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 720px;
    max-height: 80vh;
    background: #fff;
    border-radius: 20px;
    overflow: hidden;
    box-shadow: 0 24px 60px rgba(0, 0, 0, 0.25);
  }

  .pm-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, #2eb872 0%, #2b6a4e 100%);
  }

  .close-button {
    position: absolute;
    top: 16px;
    right: 16px;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    border: none;
    background: #f1f3f5;
    color: #6b7280;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 2;

    &:hover {
      background: #e9ecef;
      color: #2a2a2a;
    }

    i {
      font-size: 20px;
    }
  }

  .pm-body {
    flex: 1;
    overflow-y: auto;
    padding: 28px 28px 16px;
  }

  .prompt-expert {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 18px;

    .expert-avatar {
      width: 44px;
      height: 44px;
      border-radius: 50%;
      object-fit: cover;
      background: #2b6a4e;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      font-weight: 600;
      flex-shrink: 0;
    }

    .expert-name {
      font-size: 15px;
      font-weight: 700;
      color: #1a1a1a;
    }

    .expert-handle {
      font-size: 13px;
      color: #718096;
    }
  }

  .prompt-modal-title {
    font-size: 26px;
    font-weight: 700;
    color: #1a1a1a;
    margin: 0 0 14px;
    line-height: 1.25;
  }

  .prompt-modal-topics {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-bottom: 18px;

    .topic-chip {
      font-size: 13px;
      color: #4a5568;
      background: #f4f4f5;
      border: 1px solid #e8e8ec;
      border-radius: 999px;
      padding: 6px 14px;
    }
  }

  .prompt-modal-body {
    background: #f7f7f8;
    border: 1px solid #ececef;
    border-radius: 14px;
    padding: 20px;
    font-size: 15px;
    line-height: 1.7;
    color: #2a2a2a;
    white-space: pre-wrap;
    word-break: break-word;
  }

  .config-eyebrow {
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 1.5px;
    color: ${colors.$gray500};
    margin-bottom: 8px;
  }

  .config-summary {
    font-size: 14px;
    line-height: 1.6;
    color: ${colors.$gray600};
    margin: 0 0 20px;
  }

  .config-label {
    font-size: 14px;
    font-weight: 500;
    color: ${colors.$gray700};
    margin-bottom: 10px;
  }

  .pm-footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
    flex-shrink: 0;
    padding: 16px 28px;
    border-top: 1px solid #ececef;
  }

  .copy-button {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    border: 1px solid #e2e8f0;
    background: #fff;
    color: #2a2a2a;
    border-radius: 999px;
    padding: 9px 18px;
    font-size: 14px;
    font-weight: 500;

    i {
      font-size: 18px;
    }

    &:hover {
      background: #f7fafc;
    }
  }

  .use-button {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    border: none;
    color: #fff;
    border-radius: 999px;
    padding: 9px 20px;
    font-size: 14px;
    font-weight: 600;
    background: linear-gradient(135deg, #2eb872 0%, #2b6a4e 100%);

    i {
      font-size: 18px;
    }

    &:hover {
      color: #fff;
      filter: brightness(0.96);
    }

    &:disabled {
      opacity: 0.6;
    }
  }
`;
